module.exports = __webpack_public_path__ + "media/images/flags/bv-32b4f3da129df582461489d172623edb.svg";